exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "instance-settings .users-creation-form-container{border:1px solid #a9a9a9;padding:5px}instance-settings .data-direct-login-link{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./app/instance-settings/instance-settings.less
// module id = ./node_modules/css-loader/index.js!./node_modules/less-loader/dist/cjs.js!./app/instance-settings/instance-settings.less
// module chunks = 8